/**
 * @generated SignedSource<<3e38c00cda3b01acfb59925c51789197>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionCountdownLazy_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionCountdown_item">;
  readonly " $fragmentType": "PdpSharedAuctionCountdownLazy_item";
};
export type PdpSharedAuctionCountdownLazy_item$key = {
  readonly " $data"?: PdpSharedAuctionCountdownLazy_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionCountdownLazy_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionCountdownLazy_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionCountdown_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "2009c46cfc14499747c09c66dde3694b";

export default node;
